import { useContext } from 'react'
import { View, Text, useWindowDimensions } from 'react-native'
import { MessageCircle } from 'lucide-react-native'
import { ContactForm } from '../ContactForm'
import { LanguageContext } from '../../../src/i18n'
import { landingCtaBandStyles as styles } from './LandingCtaBand.styles'
import { LANDING_PHONE_MAX_WIDTH } from '../../../src/landing/constants/landingMarketingBreakpoints.constants'

const CTA_STACKED_WIDTH = 940
const CTA_PHONE_WIDTH = LANDING_PHONE_MAX_WIDTH

export function LandingCtaBand() {
  const { width } = useWindowDimensions()
  const languageContext = useContext(LanguageContext)
  if (!languageContext) {
    throw new Error('LandingCtaBand must be used within LanguageProvider')
  }
  const { t } = languageContext
  const isStacked = width > 0 && width < CTA_STACKED_WIDTH
  const isPhone = width > 0 && width < CTA_PHONE_WIDTH

  return (
    <View style={[styles.section, isPhone && styles.sectionPhone]} nativeID="contact">
      {isPhone && (
        <Text style={styles.sectionEyebrow}>{t.siteNav.contact}</Text>
      )}
      <View style={[styles.contactCard, isStacked && styles.contactCardStacked, isPhone && styles.contactCardPhone]}>
        <View style={[styles.copy, isStacked && styles.copyStacked, isPhone && styles.copyPhone]}>
          {!isPhone && (
            <View style={styles.badge}>
              <MessageCircle size={16} color="#6B46C1" />
              <Text style={styles.badgeText}>{t.siteNav.contact}</Text>
            </View>
          )}
          <Text style={[styles.h2, isPhone && styles.h2Phone]}>{t.contact.title}</Text>
          <Text style={[styles.p, isStacked && styles.pStacked, isPhone && styles.pPhone]}>
            {t.contact.subtitle}
          </Text>
        </View>
        <View style={[styles.formWrap, isPhone && styles.formWrapPhone]}>
          <ContactForm
            translations={{
              nameLabel: t.contact.form.nameLabel,
              emailLabel: t.contact.form.emailLabel,
              messageLabel: t.contact.form.messageLabel,
              submitButton: t.contact.form.submitButton,
              submitting: t.contact.form.submitting,
              successMessage: t.contact.form.successMessage,
              errorMessage: t.contact.form.errorMessage,
              namePlaceholder: t.contact.form.namePlaceholder,
              emailPlaceholder: t.contact.form.emailPlaceholder,
              messagePlaceholder: t.contact.form.messagePlaceholder,
              validation: t.contact.form.validation,
            }}
          />
        </View>
      </View>
    </View>
  )
}
